import { RatingTable } from "callable-data-objects";
import useCheckRole from "Hooks/APICheckRole";
import { useRatingTable } from "Hooks/Endpoints";
import React, { Fragment } from "react";
import { Button, Card, Grid, Input, Table } from "semantic-ui-react";
import BillingMenu from "../BillingMenu";

type RatingTableListProps = {
  selectView: Function;
};

const RatingTableList = ({ selectView }: RatingTableListProps) => {
  const { hasRole, roles } = useCheckRole();
  const {
    ratingTables,
    select,
    search,
    setSearch,
    createRatingTable,
  } = useRatingTable();
  const filtered = ratingTables.filter(
    (rt: RatingTable) => rt.name.indexOf(search) > -1
  );
  return (
    <Fragment>
      <BillingMenu view='rates' selectView={selectView} />
      <div style={{ padding: "20px" }}>
        <Card fluid>
          <Card.Content>
            <Grid stackable padded>
              <Grid.Column width={14}>
                <Input
                  value={search}
                  placeholder='Search...'
                  onChange={(value, data) => setSearch(data.value)}
                  icon='search'
                />
              </Grid.Column>
              <Grid.Column width={2} style={{ textAlign: "right" }}>
                {hasRole(roles.billing.rates.roles.create) && (
                  <Button primary onClick={() => createRatingTable()}>
                    Create
                  </Button>
                )}
              </Grid.Column>
            </Grid>

            <Table celled padded stackable>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell singleLine>Name</Table.HeaderCell>
                  <Table.HeaderCell singleLine>Description</Table.HeaderCell>
                  <Table.HeaderCell singleLine>Applied At</Table.HeaderCell>
                  <Table.HeaderCell singleLine>Type</Table.HeaderCell>
                  {hasRole(roles.billing.rates.roles.edit) && (
                    <Table.HeaderCell width={1}>Actions</Table.HeaderCell>
                  )}
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {filtered.map((rt: RatingTable) => (
                  <Table.Row key={`tr-ddi-${rt.id}`}>
                    <Table.Cell singleLine>{rt.name}</Table.Cell>
                    <Table.Cell singleLine>{rt.description}</Table.Cell>
                    <Table.Cell singleLine>{rt.appliedAt}</Table.Cell>
                    <Table.Cell singleLine>{rt.type}</Table.Cell>
                    {hasRole(roles.billing.rates.roles.edit) && (
                      <Table.Cell textAlign='left'>
                        <Button
                          primary
                          size='tiny'
                          onClick={() => select(rt.id)}
                        >
                          Select
                        </Button>
                      </Table.Cell>
                    )}
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
          </Card.Content>
        </Card>
      </div>
    </Fragment>
  );
};

export default RatingTableList;
